exports = module.exports = require("../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".mapboxgl-popup-close-button {\n  display: none !important;\n}\n\n.mapboxgl-canvas {\n  width: 100% !important;\n  height: 100% !important;\n  position: relative !important;\n}\n\n.marker {\n  background-size: cover !important;\n  width: 50px;\n  height: 50px;\n  cursor: pointer;\n}\n", ""]);

